import { render, staticRenderFns } from "./ClientFusionModal.vue?vue&type=template&id=1aa00ea5"
import script from "./ClientFusionModal.vue?vue&type=script&lang=ts"
export * from "./ClientFusionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports